import React from 'react';

const AsyncUsersList = React.lazy(() => import('./ListContainer'));

export const UsersListPage = () => {
  return <AsyncUsersList />;
};
